import React, { useState } from "react";
import { useIntl, defineMessages, FormattedMessage } from "react-intl";
import { Button } from "@fluentui/react-northstar";

export default function AwardAmountListOfValues(props) {
  const program = props.program;
  const budgetList = props.budgetList;
  const recipients = props.recipients;
  const callback = props.callback;

  const [pointsPer, setPointsPer] = useState();
  const [totalPoints, setTotalPoints] = useState(0);
  const [projectedBalance, setProjectedBalance] = useState(budgetList.balance);

  const intl = useIntl();
  const messages = defineMessages({
    alertPointsExceeded: {
      id: "app.awardAmountListOfValues.alertPointsExceeded",
      defaultMessage: "Points to be awarded exceeds points available.",
    },
    alertInvalidPointAmount: {
      id: "app.awardAmountListOfValues.alertInvalidPointAmount",
      defaultMessage: "You must select a valid number of points per recipient.",
    },
  });

  const pointsValueChange = (newVal) => {
    const calculatedTotalPoints = newVal * recipients.length;
    if (calculatedTotalPoints > budgetList.balance) {
      alert(intl.formatMessage(messages.alertPointsExceeded));
      return false;
    }

    setProjectedBalance(budgetList.balance - calculatedTotalPoints);

    setPointsPer(newVal);
    setTotalPoints(calculatedTotalPoints);
  };

  const applyButtonClick = () => {
    if (totalPoints === 0 && program.awardAmountPolicy?.required) {
      alert(intl.formatMessage(messages.alertInvalidPointAmount));
      return false;
    }

    if (totalPoints > budgetList.balance) {
      alert(intl.formatMessage(messages.alertPointsExceeded));
      return false;
    }

    callback(pointsPer);
  };

  const pillClick = (newPointValue, target) => {
    pointsValueChange(newPointValue);

    var pills = document.getElementsByClassName("pill");

    [].forEach.call(pills, (el) => {
      el.classList.remove("pill-selected");
    });

    target.classList.add("pill-selected");
  };

  const getValidTiers = (awardTiers = []) => {
    if (!awardTiers.length) {
      return [];
    }

    awardTiers = Object.values(awardTiers);
    return awardTiers.filter(
      (tier) => budgetList.balance >= tier * recipients.length
    );
  };

  return (
    <>
      {budgetList && (
        <>
          <div className="award-point-options mb-2">
            <p className="ml-1">
              <FormattedMessage
                id="app.awardAmountListOfValues.selectPointsPerRecipient"
                defaultMessage="Select the amount you would like to give to each recipient"
              />
            </p>
            {program.awardAmountPolicy?.required === false && (
              <>
                <div
                  className="pill"
                  onClick={(e) => {
                    pillClick(0, e.target);
                  }}
                >
                  <FormattedMessage
                    id="app.awardAmountListOfValues.noPoints"
                    defaultMessage="None"
                  />
                </div>
              </>
            )}
            {program.awardAmountPolicy?.values &&
              getValidTiers(program.awardAmountPolicy?.values).map(
                (val, index) => {
                  return (
                    <div
                      className="pill"
                      key={`amt-val-${index}`}
                      onClick={(e) => {
                        pillClick(val, e.target);
                      }}
                    >
                      {val}
                    </div>
                  );
                }
              )}
            <div className="clear-both" />
          </div>
          <div className="mt-5 ml-1 font-bold">
            <FormattedMessage
              id="app.awardAmountListOfValues.totalPoints"
              defaultMessage="Total Points Awarded:"
            />{" "}
            {totalPoints.toLocaleString()}
            <br />
            {budgetList.displayBalance === true ? (
              <FormattedMessage
                id="app.recognition.balance"
                defaultMessage="Balance: {value}"
                values={{
                  value: projectedBalance.toLocaleString(),
                }}
              />
            ) : (
              ""
            )}
          </div>
          <div className="text-center mt-5 mb-5">
            <Button
              className="text-lg px-4 py-2 rounded primary-btn"
              onClick={() => {
                applyButtonClick();
              }}
            >
              <FormattedMessage
                id="app.awardAmountListOfValues.apply"
                defaultMessage="Apply"
              />
            </Button>
          </div>
        </>
      )}
    </>
  );
}
